export const base64ToBlob = async (base64: string): Promise<Blob> => {
  const response = await fetch(base64)
  return await response.blob()
}
